/**
 * Single source of truth for the UI category <-> database category mapping.
 *
 * The UI shows audio-equipment categories; the Product schema stores a fixed
 * generic enum. Three different versions of this mapping previously existed
 * (here, in ProductsPage, and in AdminProductForm) and they disagreed, so a
 * product saved under one label was filtered under another and displayed as a
 * third. The two maps below are exact inverses of each other, which is what
 * keeps save, filter and display consistent.
 */

export const UI_CATEGORIES = [
  'LOUDSPEAKERS',
  'SPEAKERS',
  'CABINETS',
  'AMPLIFIERS',
  'MIXERS',
  'DJ CONSOLES',
  'OTHERS',
];

export const UI_TO_DB = {
  LOUDSPEAKERS: 'Audio',
  SPEAKERS: 'Home',
  CABINETS: 'Accessories',
  AMPLIFIERS: 'Computers',
  MIXERS: 'Tablets',
  'DJ CONSOLES': 'Electronics',
  OTHERS: 'Other',
};

export const DB_TO_UI = Object.entries(UI_TO_DB).reduce((acc, [ui, db]) => {
  acc[db] = ui;
  return acc;
}, {});

export const toDbCategory = (uiCategory) => UI_TO_DB[uiCategory] || uiCategory;
export const toUiCategory = (dbCategory) => DB_TO_UI[dbCategory] || dbCategory;
